import {Component, Vue} from 'vue-property-decorator'
import {UserModule} from '@/store/modules/user'
import {
    delFinanceMarketCostById,
    getFinanceMarketCost,
    setFinanceMarketCostStatus,
    financeMarketCostExportData, syncFinanceMarketCostToEkuaibao
} from '@/api/financial-center'
import {menuBtn} from '@/utils/menu_level2_button'
import {gettHeaderByType, settHeaderByType} from "@/api/common";
import {delNullProperty} from "@/utils";
import {formatDate} from "@/utils/timeFilter";

// 来源filter
Vue.filter('feeTypefilter', (value: any) => {
    const genderStr = ['合作顾问额外奖励', '中小顾问积分奖励', '学生奖学金申请','市场活动费用','其他']
    return genderStr[value * 1]
})

@Component({})
export default class MarketCost extends Vue {
    // 删除
    delOrderId: number = null
    delOrderDialogShow = false
    // 撤回审批
    // cancelApproveDialog = false
    // cancelApproveId: number = undefined

    // data
    tableHeadPopoverShow = false
    tableHeader: { filds: string; cnFilds: string; isShow: boolean; id: number }[] = []
    tableHead: any[] = []
    tableData = []
    tableRandom = Math.random()
    tableLoading = false
    page = 1
    limit = 20
    total = 0
    tableHeadFilter: any = {
        types: '', // 费用类型 /10’-合作顾问额外奖励，“1’'-中小顾问积分奖励，'2’-学生奖学金申请， "3'-市场活动费用，‘4'-其他
        code: '',// 市场费用编号
        status: '',//
        directorUserIdList: [],//
        payStatus: '',
        payName:'',
        // createdAt: [] // 创建时间
    }
    // filter_userIdList: string [] = []
    filter_createdAt: Date[] = []

    // types = ''
    tableCheckedData = []
    departmentList = []
    dialogShow = false
    receiverUser = '' // 修改后的负责人
    tableKey = Math.random()
    loading = false
    exportButtonDisabled = false
    cancelApproveDialog = false
    cancelApproveId = ''
    reviewId = NaN
    action = ''
    timer = null
    // dialogVisible = false
    // isReadonly = false
    syncVisible = false
    marketCostId = ''
    draggableList = []
    draggableListChange = []

    menuBtn = menuBtn

    // computed
    get userList() {
        return UserModule.userList
    }

    get createdAt() {
        let str = ''
        if (this.filter_createdAt && this.filter_createdAt.length > 0) {
            str = formatDate('yyyy-MM-dd', new Date(this.filter_createdAt[0])) + '&' + formatDate('yyyy-MM-dd', new Date(this.filter_createdAt[1]))
        }
        return str
    }

    /* created */
    created() {
        this.gettHeaderByType()
        // this.getTableData()
    }

    // 表头
    async gettHeaderByType() {
        const data: any = await gettHeaderByType(14)
        this.draggableListChange = data.headerUserList
        this.tableHead = JSON.parse(JSON.stringify(data.headerUserList))
        this.draggableList = JSON.parse(JSON.stringify(data.headerUserList))
        this.getTableData()
    }

    openDtatisticsData() { //统计报表
        window.open(window.location.origin + this.$route.matched[0].path + '/statisticalReport', '_blank')
    }

    // 列表
    async getTableData() {
        this.tableLoading = true

        const obj = {
            ...this.tableHeadFilter,
            limit: this.limit,  //条数/页
            page: this.page, //页码
            createdAt: this.createdAt
        }

        const data: any = await getFinanceMarketCost(delNullProperty(obj))
        this.tableData = data.financeMarketCostList
        this.total = data.allNum
        this.tableLoading = false
        // this.isReadonly = false
        this.tableKey = Math.random()
        // this.tableData.forEach(item => {
        //     if (item.finance_market_cost_account) {
        //         item.finance_market_cost_accountStatus = item.finance_market_cost_account.status
        //     }
        // })
        this.$nextTick(() => {
            (this.$refs.multipleTable as HTMLFormElement).doLayout();
            (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
        });
    }
    // 同步单据
    syncMarkCost(row){
        this.marketCostId = row.id
        this.syncVisible = true
    }

    async syncDialogConfirm() {
        this.syncVisible = false
        await syncFinanceMarketCostToEkuaibao({id: this.marketCostId})
        this.$message.success('同步单据成功')
    }

    // 导出
    async exportExcel() {
        this.exportButtonDisabled = true
        this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        const obj = {
            types: this.tableHeadFilter.types,
            code: this.tableHeadFilter.code,
            status: this.tableHeadFilter.status,
            createdAt: this.createdAt,
            directorUserIdList : this.tableHeadFilter.directorUserIdList,
            payStatus: this.tableHeadFilter.payStatus,
            payName: this.tableHeadFilter.payName,

        }
        for (const key in obj) {
            if (!obj[key]) {
                delete obj[key]
            }
        }
        financeMarketCostExportData(obj).finally(() => {
            this.exportButtonDisabled = false
        })
    }

    handle() {
        document.body.click()
    }

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }

    pageSizeChange(limit: number) {
        this.limit = limit
        this.getTableData();
    }

    handleSelectionChange(row: any) {
        this.tableCheckedData = row
    }

    // 多选更换负责人
    async dialogConfirm() {
        if (!this.receiverUser) {
            this.$message.error('请选择负责人')
            return
        }
        (this.$refs['multipleTable'] as HTMLFormElement).clearSelection();
    }

    /*
    按钮权限验证
    */
    handleBtn(id: number) {
        return menuBtn(id)
    }


    /*新建费用*/
    openNewCost() {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/marketCostAdd', '_blank')
        const timer = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(timer)
            }
        }, 500)
    }

    clickEditButton(row) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/marketCostInfo?id=' + row.id + '&status=' + row.status + '&isShow=' + row.isShow + '&type=编辑' + '&isUpdatedData=0', '_blank')
        const timer = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(timer)
            }
        }, 500)
    }

    // 撤回审批
    clickcancelApproveButton(row) {
        this.cancelApproveId = row.id
        this.cancelApproveDialog = true
    }

    clickCancelApproveDialogConfirmButton(row) {
        if (this.action === '0') {
            const win = window.open(window.location.origin + this.$route.matched[0].path + '/marketCostInfo?id=' + row.id + '&status=' + row.status + '&type=编辑' + '&isUpdatedData=1', + '&isShow=' + row.isShow)
            const timer = setInterval(() => {
                if (win.closed) {
                    this.getTableData()
                    clearInterval(timer)
                }
            }, 500)
            return
            // const win = window.open(window.location.origin + this.$route.matched[0].path + '/makeInvoiceInfo?id=' + row.id+ '&status=' + row.status+ '&type=编辑' + '&isUpdatedData=1', '_blank')
            // const timer = setInterval(() => {
            //     if(win.closed) {
            //         this.getTableData()
            //         clearInterval(timer)
            //     }
            // }, 500)
            // return
        } else {
            setFinanceMarketCostStatus({
                id: this.reviewId,
                action: this.action
            }).then(() => {
                this.$message.success(`成功${this.action === '0' ? '提交' : '撤回'}审批`)
                this.getTableData()
                this.cancelApproveDialog = false
            }).catch((err: Error) => {
                // 没有查到相关审批流程，暂时无法新建订单，请联系管理员设置审批流程
                if (err.message === '审批流报错') {
                    this.$message.error('此审批流程不适用您，请联系管理员')
                }
            })
        }
    }

    async setFinanceMarketCostStatus(row: any, action: string) {
        this.reviewId = row.id
        this.action = action
        if (action === '0') {
            this.clickCancelApproveDialogConfirmButton(row)
        } else {
            this.cancelApproveDialog = true
        }
    }


    // clickCancelApproveDialogConfirmButton() {
    //     const win = window.open(window.location.origin + this.$route.matched[0].path + '/marketCostInfo?id=' + row.id + '&status=' + row.status + '&type=编辑' + '&isUpdatedData=1', '_blank')
    //     const timer = setInterval(() => {
    //         if (win.closed) {
    //             this.getTableData()
    //             clearInterval(timer)
    //         }
    //     }, 500)
    //     return
    // }


    // 重新提交 / 撤回审批
    // async setFinanceMarketCostStatus(row: any, action: string) {
    //     if (action === '0') {
    //         const win = window.open(window.location.origin + this.$route.matched[0].path + '/marketCostInfo?id=' + row.id + '&status=' + row.status + '&type=编辑' + '&isUpdatedData=1', '_blank')
    //         const timer = setInterval(() => {
    //             if (win.closed) {
    //                 this.getTableData()
    //                 clearInterval(timer)
    //             }
    //         }, 500)
    //         return
    //     }
    //     await setFinanceMarketCostStatus({
    //         id: row.id,
    //         action
    //     })
    //     if (action == '1') {
    //         this.$message.success('成功撤回审批')
    //     }
    //     this.cancelApproveDialog = false
    //     this.getTableData()
    // }

    hendleDelClick(id) {
        this.delOrderId = id
        this.delOrderDialogShow = true
    }

    // 确定删除
    async delOrderDialogConfirm() {
        await delFinanceMarketCostById(this.delOrderId)
        this.$message.success('删除成功')
        this.delOrderDialogShow = false
        this.getTableData()
    }

    // 点击表格进入详情
    clickRow(row: any, cloumn: any) {
        if (menuBtn(124)) {
            const win = window.open(window.location.origin + this.$route.matched[0].path + '/marketCostInfo?id=' + row.id + '&status=' + row.status + '&isShow=' + row.isShow + '&isUpdatedData=0', '_blank')
            const timer = setInterval(() => {
                if (win.closed) {
                    this.getTableData()
                    clearInterval(timer)
                }
            }, 500)
        } else {
            this.$message.error('您没有查看权限');
        }
    }

    // 跳转统计图表页面
    goToDtatisticsData() {
        const {origin} = window.location
        const src = origin + '/financialCenter/statisticsReport'
        window.open(src, '_blank')
    }
    changeTable() {
        const newArr = []
        this.draggableListChange.forEach(item => {
            if (item.isShow === true) {
                newArr.push(item)
            }
        })
        if (newArr.length == 1) {
            newArr.forEach(item => {
                item.isDisBtn = true
            })
        } else {
            newArr.forEach(item => {
                item.isDisBtn = false
            })
        }
    }
    // 设置表头
    async draggableEnd() {
        this.tableHeadPopoverShow = false
        this.draggableList = this.draggableListChange
        const newArr: object = this.draggableList.filter(item =>
            item.isShow === true
        )
        if ((newArr as []).length > 0) {
            await settHeaderByType({types: 14, headerIds: this.draggableList})
            this.$message.success('表头设置成功')
            this.gettHeaderByType()
        } else {
            this.$message.error('至少保留一个表头')
        }
    }

    doCancel() {
        this.draggableListChange = JSON.parse(JSON.stringify(this.draggableList))
        console.log('this.draggableListChange ', this.draggableListChange)
        this.tableHeadPopoverShow = false
    }

}
